<template>
    <div class="shop-checkout">
        <shop-cart v-if="cart"/>
        <shop-wishlist v-if="!cart"/>
    </div>
</template>

<script>
    import {CONSTANTS} from "../shared/constants";
    import ShopCart from "../views/shop-cart/shop-cart.vue";
    import ShopWishlist from "../views/shop-wishlist/shop-wishlist.vue";

    export default {
        name: "shop-checkout",
        components: {ShopWishlist, ShopCart},
        props: {
            _mode: String
        },
        computed: {
            cart() {
                return this._mode === CONSTANTS.mode.cart;
            },
            authenticated() {
                return this.$store.getters.authenticated;
            }
        },
        created() {
            this.$store.dispatch("login");
        }
    }
</script>
